<template>
  <section>
    <cover-image src="static/bg-about.jpg" :title="$t('title.contact')" subtitle=""/>
    <div class="container">
      <div class="row content">
        <div class="col-md-6">
          <h2 class="row">SeConS</h2>
          <p class="row">
            <a href="mailto:office@secons.net" >office@secons.net</a>
          </p>
          <p class="row">{{ $t('label.address') }}: {{ $t('text.address_secons')}}</p>
          <p class="row">{{ $t('label.phone') }}: +381 11 4505 818</p>
          <p class="row">{{ $t('label.fax') }}: +381 11 4505 831</p>
          <p class="row">
            <a href="http://www.secons.net" target="_blank">www.secons.net</a>
          </p>
        </div>

        <div class="col-md-6">
          <h2 class="row">FREN</h2>
          <p class="row">
            <a href="mailto:office@fren.org.rs" >office@fren.org.rs</a>
          </p>
          <p class="row">{{ $t('label.address') }}: {{ $t('text.address_fren')}}</p>
          <p class="row">{{ $t('label.phone') }}: +381 11 3021 069</p>
          <p class="row">{{ $t('label.fax') }}: +381 69 80 421</p>
          <p class="row">
            <a href="http://www.fren.org.rs" target="_blank">www.fren.org.rs</a>
          </p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  import CoverImage from '@/components/ui/CoverImage'
  export default {
    name: 'ContactView',
    metaInfo() {
      return {
        title: this.title
      }
    },
    data() {
      return {
        title: this.$t('navigation.contact')
      }
    },
    components: {
      CoverImage
    },
    props: {
      language: String
    }
  }
</script>

<style lang="scss" scoped>
  @import '~styles/_vars.scss';

  a {
    color: $primary-color;
    font-weight: $semibold;
  }

  p {
    margin-bottom: 0.5rem;
  }

  .content {
    padding: 0 1rem 2rem 1rem;
  }

</style>



// WEBPACK FOOTER //
// ContactView.vue?52890672